module.exports = __webpack_public_path__ + "458f64a1b64a4c508bc33e15cdcef874.svg";